import { render, staticRenderFns } from "./marketingShop.vue?vue&type=template&id=399c2024&scoped=true"
import script from "./marketingShop.vue?vue&type=script&lang=js"
export * from "./marketingShop.vue?vue&type=script&lang=js"
import style0 from "./marketingShop.vue?vue&type=style&index=0&id=399c2024&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "399c2024",
  null
  
)

export default component.exports